
import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {NgModule} from '@angular/core';
import {DataTableModule,TabViewModule,PanelModule,OverlayPanelModule,ButtonModule,GMapModule,PaginatorModule} from 'primeng/primeng';
import {Router, RouterModule} from "@angular/router";
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import {MamAdminService} from '../../service/mam_service.component';
import { PositionLog } from '../../model/position';
import {UserGroupTreeModule} from "../../component/user_tree.component";
import {TranslateServiceForm} from "../../translate/translate.service";
import {SelectItem} from "primeng/components/common/api";
import {AttributeGroupTreeModule} from "../../component/attribute-group-tree/attribute-group-tree.component";
import {CompanyDropDownListModule} from "../../component/company-drop-down-list/company-drop-down-list.component";
import {DatexPipe} from "../../pipe/datex.pipe";
import {MainPipeMoudle} from "../../pipe/main.pipe";
import {Logger, Options, Level } from "angular2-logger/core";
import {SearchModule} from "../../component/search.component";
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe"; // ADD THIS

declare var google: any;

@Component({
  selector: 'location-info',
  templateUrl: 'device_location_info.html',
  encapsulation: ViewEncapsulation.None
})

export class DeviceLocationInfoComponent implements OnInit {
  private position_list : PositionLog[]  = [];
  positionList : any;
  options : any;
  deviceInformation : any;
  logList : any;
  deviceDetailInformation : any;
  overlays : any;

  selected_group: any;
  groupDeviceList : any;
  totalRecord : number =0;
  beforeIsTrue : boolean = true;
  searchIDs: SelectItem[];
  searchIsTrue: boolean;
  searchText: string;
  searchId: string;
  sDate: string;
  eDate: string;
  pageMax: number = 10;
  resetIsTrue: any = "true";


  gmap_show : boolean = false;  selectedCompany : any;  ngOnInit() {

    //this.getPositionLogList(4,1,10);
    //this.getDeviceResource(7);
    //this.getControlLogForDevice(1,10,7);
    this.options = {
      center: {lat:	37.4824783, lng:126.8953938},
      title : "ㅁㅁㅁ",
      zoom: 12
    };
  }

  private translate:TranslateServiceForm;

  constructor(private service : MamAdminService , private _translate: TranslateServiceForm, private logger : Logger) {

    this.overlays = [];
    this.searchIDs = [];
    this.translate = _translate;
    this.searchIDs.push({label: '---------------', value: 'all'});
    this.searchIDs.push({label: this.translate.instant('LANG_TargetUser'), value: 'name'});
    this.searchIDs.push({label: this.translate.instant('LANG_MemberNum'), value: 'membernum'});
    this.searchIDs.push({label: this.translate.instant('LANG_PhoneNumber'), value: 'mobilenumber'});
    this.searchIDs.push({label: this.translate.instant('IsRegistered'), value: 'isRegistered'});
    //this.overlays.push(new google.maps.Marker({position: {lat: 36.883707, lng: 30.689216}, title: ''}));

  }

  getPositionLogList(deviceId:number, page:number, max:number) {
      this.service.getPositionLogList(deviceId, page, max).subscribe(
          value => {
            this.positionList = value.rows;
            this.logger.debug("-- position_list :", this.positionList);
            
            this.overlays = [];
            if(this.positionList.length > 0 ) {
              this.positionList.forEach(position=>{
                this.overlays.push(new google.maps.Marker({position: {lat: Number(position.latitude), lng: Number(position.longitude)}, title: position.address}));
              })
            }
          },error => { this.logger.error("-- error : " + error); },
          () => {
            
            this.gmap_show = true;
          }
        )
  }

  getDeviceResource(deviceId:number) {
    this.service.getDeviceResource(deviceId).subscribe(
      value => {
        let detailItem = [];
        for(let i=0;i<18;i++){
          let obj = {key : "", itemValue :""};
          if(i <=9){ obj.key= "100"+i; }else{ obj.key = "200"+(i-9); }
          detailItem.push(obj);
        }


        //this.deviceResourceList = value;
        if(value.length > 0){
          this.deviceDetailInformation = value;
          this.deviceDetailInformation.forEach(item => {
            detailItem.forEach( detail => {
              if(item.itemKey == detail.key){
                detail.itemValue = item.itemValue;
        }
            })
          });
        }

        this.deviceDetailInformation = detailItem;
        this.logger.debug("detailItem",detailItem);

        this.logger.debug("-- device_resource_list :", value);
        this.logger.debug("deviceDetailInformation : ",this.deviceDetailInformation);
      },
      
      error => {this.logger.error("-- error : " + error);},
      () => {}
    )
  }

  getControlLogForDevice(page:number, max:number, deviceId:number) {
    this.service.getControlLogForDevice(page, max, deviceId).subscribe(
      value => {
        this.logList = value.content;
        let log_list = value;
        this.logger.debug("-- log_list :", value);
        for(var i=0; i < this.logList.length; i++) {
          this.logList[i].message = this.translate.instant(this.logList[i].message);
          this.logList[i].status = this.translate.instant(this.logList[i].status);
        }
      },
      error => {
        this.logger.error("-- error : " + error);
      },
      
      () => {}
    )
  }

  getGroupDevice(groupId: number, page: number, size: number){
    this.service.getGroupDevice(groupId,page,size).subscribe(
      value => {
        this.groupDeviceList = value.content;
        this.totalRecord = value.totalElements;

        this.logger.debug("-- groupDeviceList : ",this.groupDeviceList);
      },
      
      error => {this.logger.error("-- error : " + error);},
      () => {}
    )
  }

  getGroupDeviceBySearch(groupId:number,page:number,size:number, search:string, field:string){
    this.service.getGroupDeviceBySearch(groupId,page,size,search,field).subscribe(
        value => {
            this.groupDeviceList = value.content;
            this.totalRecord = value.totalElements;
            this.logger.debug("-- getGroupDeviceBySearch : ",this.groupDeviceList);
        },
        error => {
            this.logger.error("-- error : " + error);
        },
        () => {
            this.logger.info("-- complate : ");
        }
    )
  }


  onGroupSelect(event){
    this.selected_group = event;
    this.getGroupDevice(event.id,0,5);

  }

  onRowSelect(event){
    this.logger.debug("select data",event.data);
    this.beforeIsTrue = false;
    this.deviceInformation = event.data;
    this.deviceInformation.binaryFilePath = "img_mobile_"+ this.deviceInformation.deviceTypeId.modelName+".jpg";

    this.getDeviceResource(this.deviceInformation.id);
    if(this.deviceInformation.allowedLocationMonitoring){
        //this.getControlLogForDevice(1,10,this.deviceInformation.id);
        this.getPositionLogList(this.deviceInformation.id,1,10);
    }else{
        alert(this.translate.instant('LANG_Location_Information_Not_Available'));
        this.gmap_show = false;
        this.positionList = [];
    }

  }

  paginate(event) {
    this.pageMax = event.rows;
    if (this.searchIsTrue) {
        this.getGroupDeviceBySearch(this.selected_group.id,event.page,this.pageMax, this.searchText, this.searchId);
    } else {
        this.getGroupDevice(this.selected_group.id,event.page,this.pageMax);
    }
  }

  onSelectedCompany(company) {
    this.selectedCompany = company;
    this.logger.debug("combo - select :" , this.selectedCompany);
  }

  getSearchModel(event) {
    this.logger.debug("event : ", event);
    this.searchIsTrue = event.searchIsTrue;
    this.searchText = event.searchText;
    this.sDate = event.sDate;
    this.eDate = event.eDate;
    this.searchId = event.searchId;

    if (this.searchId == "all") {
        this.searchIsTrue = false;
        this.getGroupDevice(this.selected_group.id, event.page, this.pageMax);
    } else {
        this.getGroupDeviceBySearch(this.selected_group.id,event.page,this.pageMax, this.searchText, this.searchId);
    }

    //this.getGroupDeviceBySearch(this.selected_group.id,event.page,this.pageMax, this.searchText, this.searchId);
  }

  refreshPositionLog(event){
      this.getPositionLogList(this.deviceInformation.id,1,10);
  }

}

@NgModule({
  imports: [DataTableModule,TabViewModule,PanelModule,BrowserModule,HttpModule, RouterModule,OverlayPanelModule,ButtonModule,GMapModule,UserGroupTreeModule,PaginatorModule,AttributeGroupTreeModule,CompanyDropDownListModule,MainPipeMoudle,SearchModule, TranslatePipeMoudle],
  exports: [DeviceLocationInfoComponent],
  declarations: [DeviceLocationInfoComponent],
  providers: [MamAdminService],
})
export class DeviceLocationInfoModule {
}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/page/device/device_location_info.ts